import { useMemo } from 'react';
import type { MatchingSetItem } from '../../domain/models/MatchingSetItem';
import { ProductCard } from '@/features/plp/presentation/components/ProductCard';
import type { ListingDesignItem } from '@/features/plp/domain/models/ProductListing';

import { toPriceNumber, formatDisplayPrice } from '@/shared/utils/priceFormatter';

interface MatchingSetCardProps {
  item: MatchingSetItem;
  onItemClick?: (designId: number, designName: string) => void;
}

function mapMatchingSetItemToListingDesignItem(item: MatchingSetItem): ListingDesignItem {
  const parsedPrice = item.price != null ? toPriceNumber(item.price) : null;
  const parsedDiscountedPrice = item.discountedPrice != null ? toPriceNumber(item.discountedPrice) : null;

  return {
    designId: item.designId,
    designName: item.designName,
    imageUrl: item.imageUrl,
    productPageUrl: item.productPageUrl ?? '',
    price: parsedPrice !== null ? formatDisplayPrice(parsedPrice) : '₹ 0',
    discountedPrice: parsedDiscountedPrice !== null ? formatDisplayPrice(parsedDiscountedPrice) : undefined,
  };
}

export function MatchingSetCard({ item, onItemClick }: MatchingSetCardProps) {
  const mappedProduct = useMemo(() => mapMatchingSetItemToListingDesignItem(item), [item]);

  const handleProductClick = () => {
    if (onItemClick) {
      onItemClick(item.designId, item.designName);
    }
  };

  return (
    <ProductCard
      product={mappedProduct}
      className="rounded-[5px] border border-gray-200 bg-white"
      onProductClick={handleProductClick}
      hideVideoCallButton
      hideViewDetailsButton
    />
  );
}
